export default "__VITE_ASSET__d2cfff60__"